import React, { useEffect, useState } from 'react';
import axios from 'axios';
import css from './VerificationDefault.css';
import { FormattedMessage } from 'react-intl';
import SingpassButton from '../../../assets/SinpassPrimaryButton.svg';
import {
  createRawPropertiesForGTM,
  getEventsByBucket,
} from '../../../util/gtm/gtmCreateProperties';
import { triggerAnalyticsEvent } from '../../../util/amplitudeMapEvents';
import { event_trigger_ids } from '../../../util/analyticsConstants';

const VerificationDefault = ({ currentUser, selectVerificationProcess }) => {
  // Guards against a second click while the first is still fetching. Each call
  // starts a new attempt and overwrites the stored one, so two in flight would
  // leave the first authorize URL pointing at an attempt that no longer exists.
  const [isStarting, setIsStarting] = useState(false);
  const [trxnNumber, setTrxnNumber] = useState(
    Math.floor(Math.random() * 100000),
  );
  const [userId, setUserId] = useState('');

  useEffect(() => {
    if(window) {
       window.scrollTo(0, 0)
     }
  }, [])

  useEffect(() => {
    let sessionUserData = JSON.parse(sessionStorage.getItem('CURRENT_USER'));

    if(currentUser && currentUser.id.uuid) {
      setTrxnNumber(`${currentUser.id.uuid}:${trxnNumber}`);
    }
    if(sessionUserData && typeof sessionUserData === 'object') {
      setTrxnNumber(`${sessionUserData.id.uuid}:${trxnNumber}`);
    }
    if(sessionUserData && typeof sessionUserData !== 'object') {
      setTrxnNumber(`${sessionUserData}:${trxnNumber}`);
    }

    // The authorize URL is no longer prefetched here. It now comes from
    // /api/singpass/v5/config at click time, because a Myinfo v5 URL is only valid
    // for about 60 seconds after the server creates it.
  }, [setTrxnNumber, setUserId]);

  const handleSingpassClick = async () => {
    if (isStarting) return;
    setIsStarting(true);

    try {
      const response = await getEventsByBucket('guestverify');
      // console.log('Events fetched successfully:', response.data);
      triggerAnalyticsEvent({
        event_id: event_trigger_ids.GUEST_VERIFY_OPEN_FORM,
        eventData: response.data,
        props: {
          guest: currentUser
        },
        user: currentUser,
        userId: currentUser ? currentUser.id.uuid : null
      });
      // pushGTMVerifiedEmailPhone(properties, EVENT_SIGNUP_VERIFIED_EMAIL);
    } catch (error) {
      console.error('Error fetching events or triggering GTM event:', error);
    }

    // Ask the server to start an attempt and hand back a URL to open. Which
    // Myinfo version produced it is the server's decision — this page does not
    // know and does not need to, which is what lets the version be switched
    // without a frontend release.
    let sessionUserData = JSON.parse(sessionStorage.getItem('CURRENT_USER'));
    const flexUserId = currentUser
      ? currentUser.id.uuid
      : sessionUserData
      ? sessionUserData.id.uuid
      : '';

    try {
      const startResponse = await axios.get(
        `${process.env.REACT_APP_API_SERVER_URL}/api/singpass/v5/config?userId=${flexUserId}&source=web`
      );
      if (startResponse.data && startResponse.data.authorizeUrl) {
        // Leave isStarting set: the page is navigating away, and re-enabling the
        // button here would briefly allow a second attempt to be started.
        window.location.href = startResponse.data.authorizeUrl;
        return;
      }
      throw new Error('No authorizeUrl returned');
    } catch (error) {
      console.error('Failed to start Singpass verification', error);
      setIsStarting(false);
    }
  };

  return (
    <>
      <div className={css.verificationDescription}>
        <FormattedMessage id="Verification.VerifcationDescription" />
      </div>
      <div className={css.verifyBox}>
        <div className={css.verifyBoxTop}>
          <div className={css.recomendedBanner}>
            <span>
              <FormattedMessage id="Verification.VerifcationRecomendedBanner" />
            </span>
          </div>
          <div className={css.verifyMethodDetails}>
            <FormattedMessage id="Verification.SingpassDesc" />
            &nbsp;
            <a
              href="https://api.singpass.gov.sg/library/myinfo/business/introduction"
              className={css.learnMoreLink}
              target="_blank"
            >
              <FormattedMessage id="NRICSettingForm.learnMore" />
            </a>
          </div>
          <div className={css.verifyMethodAction}>
            <a
              className={css.verifySingpasButton}
              onClick={handleSingpassClick}
              style={isStarting ? { opacity: 0.6, pointerEvents: 'none' } : null}
            >
              <img src={SingpassButton} alt="React Logo" />
            </a>
          </div>
        </div>
        <div className={css.verifyBoxBottom}>
          <ul>
            <li>
              <FormattedMessage id="Verification.SingpassPros1" />
            </li>
            <li>
              <FormattedMessage id="Verification.SingpassPros2" />
            </li>
          </ul>
        </div>
      </div>
      <div className={css.verifyBox}>
        <div className={css.verifyBoxTop}>
          <div className={css.verifyMethodDetails}>
            <FormattedMessage id="Verification.ManualDesc" />
          </div>
          <div className={css.verifyMethodAction}>
            <button className={css.verifyManualButton} onClick={() => selectVerificationProcess()}>
              Complete Verification
            </button>
          </div>
        </div>
        <div className={css.verifyBoxBottom}>
          <ul>
            <li>
              <FormattedMessage id="Verification.ManualPros1" />
            </li>
            <li>
              <FormattedMessage id="Verification.ManualPros2" />
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default VerificationDefault;